import { render, staticRenderFns } from "./ProtocolsTable.vue?vue&type=template&id=6b9de44c&"
import script from "./ProtocolsTable.vue?vue&type=script&lang=js&"
export * from "./ProtocolsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports